import { useCallback } from 'react';
import { sumTokenCounts, trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';

const useTrackCloseClicked = () => {
  const { productEvents, initialPrompt } = useConfigContext();
  const { findMessagesBy, getMessageDatas } = useMessagesContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);
    const allMessageContent = getMessageDatas().map((message) => message.content);
    const totalTokens = sumTokenCounts([initialPrompt, ...allMessageContent]);

    trackProductAnalytics('Close Clicked', {
      'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
      'Total Tokens': totalTokens,
    });
  }, [productEvents, findMessagesBy, getMessageDatas, initialPrompt]);

  return trackCallback;
};

export default useTrackCloseClicked;
